<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Manage Admin</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
          >
            <v-form ref="form" v-model="frmValid">
              <v-text-field
                v-model="txtName"
                label="Name"
              ></v-text-field>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="caption"
                item-value="value"
                label="Sorting"
              ></v-select>
              <v-btn
                :disabled="!frmValid"
                @click="items=[]; getAdmins(txtName, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-list two-line fill-height>
        <div v-for="(item, index) in items" :key="index">
          <v-list-tile
            :key="item.userId"
            avatar
            ripple
            :to=itemUrl(item.userId)
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.loginEmail }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>Created: {{ item.createdDateTimeDisplay }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>{{ item.roleName }}</v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </div>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No admin yet
            </div>
          </v-flex>
        </template>
      </v-list>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          to="/admin"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      cboSort: null,
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Name',
          value: 'name:asc'
        }
      ],
      items: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getAdmins()
    this.detectBottomOfWindow()
  },

  methods: {
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getAdmins(_this.txtName, _this.cboSort, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48;
        // console.log(document.documentElement.offsetHeight);
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getAdmins(this.txtName, this.cboSort, this.items.length)
          }
        }
      }
    },
    getAdmins: function (name = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?name=' + name + '&sort=' + sort + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c = 0; c < resp.data.data.length; ++c) {
                resp.data.data[c].createdDateTimeDisplay = moment(resp.data.data[c].createdDateTime, _this.iso8601Format()).fromNow()
              }
              _this.items = _this.items.concat(resp.data.data)
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
            } else {
              console.log('unable to load admins: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    itemUrl: function (id) {
      return '/admin/' + id
    },
    clearFilter () {
      this.$refs.form.reset()
      this.items = []
      this.getAdmins(this.txtName, this.cboSort)
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
